<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Item Details

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-5px padding-left-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">VoucherNo</h4></div>
            <div class="margin-bottom-10px" *ngIf="Voucherno"><h4 class="margin-bottom-0px display-inline color-Checkin">{{Voucherno}}</h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Facility Name</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign">GGHo</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Date</h4></div>
            <div class="margin-bottom-10px" *ngIf="ReDate"><h4 class="margin-bottom-0px display-inline">{{ReDate| date:'MMM-dd-yyyy'}}</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Total Amount</h4></div>
            <div class="margin-bottom-10px" *ngIf="TotalAmount"><h4 class="margin-bottom-0px display-inline ">{{TotalAmount}}</h4></div>
          </div>


          <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
      <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
      <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
    </div>
    <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
      <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
      <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
    </div>-->
        </div>
        
          <div class="modal-body padding-top-0px padding-left-10px">








            <div class="row">
              <div class="col-md-12">
                <div class="table-component">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-zero width-100pe"
                           cols="auto,2*,*,*,*,*,*,*">

                      <thead class="">
                        <tr>

                          
                        
                          
                          <!--<th class="text-align-center">Start Time</th>-->
                          

                          <!--<th class="">
                Prime Relation
              </th>-->

                          <th class="padding-top-4px padding-bottom-4px">
                            Item Description
                          </th>
                          <th class="padding-top-4px padding-bottom-4px padding-right-5px">
                            Item Amount
                          </th>
                          

                          




                        </tr>
                      </thead>

                      <tbody class="table-body">
                        <!--<tr *ngFor="let l of CurrentExpenseVoucherController">

              <td class="td-padding-tb">{{l.VoucherID}}</td>


              <td class=" td-padding-tb">{{l.Date| date:'MMM-dd-yyyy'}}</td>


              <td class=" td-padding-tb">
                {{l.EmployeeName}}
              </td>



              <td class="td-padding-tb">{{l.Purpose}}</td>

              <td class="td-padding-tb  text-align-right">{{l.ItemAmount}}</td>
              <td class="td-padding-tb  ">{{l.PaymentType}}</td>
              <td class="td-padding-tb  ">{{l.ApprovedByName}}</td>
              <td class="td-padding-tb ">{{l.Facility}}</td>
              <td class="td-padding-tb ">
                <button type="button" (click)="ViewItem()" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime-man actions-btn-prime3 margin-left-auto font-size-13px padding-left-5px padding-right-5px min-width-32px">
                  <i class="fa fa-ellipsis-h"></i>
                </button>
                <button class="btn font-size-13px actions-btn-prime  margin-left-5px">Cancel Voucher</button>

              </td>





            </tr>-->
                        <tr *ngFor="let l of CurrentExpenseVoucherController">

                         


                          <td class="td-padding-tb">{{l.Particulars}}</td>

                          <td class="td-padding-tb  text-align-center padding-right-0px">{{l.CreditAmount}}</td>
                        





                        </tr>
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>




















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>

          </div>
       
      </div>
    </div>
  </div>
</div>
